import React from "react";
import { Button, Container, Nav, Navbar } from "react-bootstrap";
import { HashLink } from "react-router-hash-link";
import "./Header.css";


const Header = () => {
   return (
      <div>
         <Navbar
            className="p-4 fixed-top"
            bg="dark"
            variant="dark"
            collapseOnSelect
            expand="lg"
         >
            <Container className="container">
               <Navbar.Brand href="/home">
                  {" "}
                  <span className="fs-5 fw-bold">
                     {" "}
                     <i class="fas fa-code"></i> Bakhtiar{" "}
                  </span>{" "}
               </Navbar.Brand>
               <Navbar.Toggle />
               <Navbar.Collapse className="justify-content-end hover-effect">
                  <Nav.Link
                     as={HashLink}
                     to="/home"
                     className="text-white fs-5 fw-bold nav-links"
                     style={{ marginRight: "50px" }}
                  >
                     Home
                  </Nav.Link>
                  <Nav.Link
                     as={HashLink}
                     to="/about"
                     className="text-white fs-5 fw-bold nav-links"
                     style={{ marginRight: "50px" }}
                  >
                     About
                  </Nav.Link>
                  <Nav.Link
                     as={HashLink}
                     to="/projects"
                     className="text-white fs-5 fw-bold nav-links"
                     style={{ marginRight: "50px" }}
                  >
                     Projects
                  </Nav.Link>
                  <Nav.Link
                     as={HashLink}
                     to="/blog"
                     className="text-white fs-5 fw-bold nav-links"
                     style={{ marginRight: "50px" }}
                  >
                     Blog
                  </Nav.Link>
                  <Nav.Link
                     as={HashLink}
                     to="/contact"
                     className="text-white fs-5 fw-bold nav-links"
                  >
                     Contact
                  </Nav.Link>

                  {/*  <a
                        className="text-decoration-none fs-5 fw-bold"
                        // href="https://drive.google.com/u/1/uc?id=17GekidaqoFM4cWCpIj_sjd-VzhXeOaky&export=download"
                     >
                        <Button>
                           {" "}
                           <i className="fas fa-file-download me-1"></i> Resume
                        </Button>
                     </a> */}
               </Navbar.Collapse>
            </Container>
         </Navbar>
      </div>
   );
};

export default Header;
